import Vue from "vue";
import { debounce } from 'lodash';

Vue.component("notification-autocomplete", {
    props: ["value",
        "language",
        "disabled",
        "placeholder",
        "notificationFormatId",
        "maxtags",
        "allowedFormats",
        "allowNew",
        "countryId",
        "refName"
    ],
    data() {
        return {
            isFetching: false,
            data: [],
            selected: null,
            myValue: null,
            isDisabled: this.disabled,
            refNameCustom: this.refName ? this.refName : `notificationAutocomplete${ crypto.randomUUID()}`
        };
    },
    watch: {
        myValue: function (value) {
                console.log(` value ${value}`);

            if (value && value != this.value) {
                console.log(` value ${value}`);
                let tempValue = [];
                value.forEach(member => {
                    console.log(`member ${member}`);
                    if (member.id) {
                        tempValue.push(member.id);

                    } else {
                        tempValue.push(member);

                    }
                });
                console.log(` temp ${tempValue}`)
                this.$emit("update:value", tempValue);
            }

        },
        selected: function (val) {
            if (val && value != this.value) {

                this.$emit("update:value", val.id);


                //this.myValue = val.notifyingPartyReference;
            }
        },
        notificationFormatId: function (val) {
            if (val) {
                this.getAsyncData();
            }
        },
        countryId: function (val) {
            this.isFetching = true;


            console.log(val)
            this.$services.notifications.getAutocomplete({
                language: this.language,
                notificationFormatId: this.notificationFormatId,
                formats: this.allowedFormats,
                partyId: val
            })
                .then((data) => {
                    this.data = []

                    this.isFetching = false;
                    if (data.items) {


                        data.items.forEach((item) => this.data.push(item))

                        if (this.value) {
                            this.myValue = this.value;

                        }
                    }

                });

        }
    },
    methods: {
        getAsyncData: debounce(function (symbol) {
            //if (!query.length) {
            //    this.data = []
            //    return
            //}
            console.log(this.notificationFormatId)

            this.isFetching = true;

            this.$services.notifications.getAutocomplete({
                language: this.language,
                symbol: symbol,
                notificationFormatId: this.notificationFormatId,
                formats: this.allowedFormats,
                partyId: this.countryId
            }).then((data) => {
                this.data = []
                if (data.items) {
                    data.items.forEach((item) => this.data.push(item))
                }
                this.isFetching = false;
            });
        }, 500)
    },
    created() {
        this.isFetching = true;

        console.log(this.notificationFormatId)
        this.$services.notifications.getAutocomplete({
            language: this.language,
            notificationFormatId: this.notificationFormatId,
            formats: this.allowedFormats,
            partyId: this.countryId
        })
            .then((data) => {

                this.data = []
                if (data.items) {


                    data.items.forEach((item) => this.data.push(item))

                    if (this.value) {
                        this.myValue = this.value;

                    }
                }

            });



    },
    template: `
        <div>
            <b-taginput 
				autocomplete
                :ref="refNameCustom"
				v-model="myValue"
				:data="data"
				@typing="getAsyncData"
				field="text"
                :maxtags="maxtags == 0 ? null : maxtags"
				:open-on-focus="true"
                :allow-new="allowNew"
			>
			</b-taginput>
        </div>
    `
});